<div class="wrapper" [ngClass]="{'active': active}" [id]="id">
    <div class="title" *ngIf="!hideTitle">
        <span class="clr-title">Pick</span>
    </div>
    <div class="color-box" [(colorPicker)]="color" [style.background]="color" [cpPosition]="'top-left'"
        [cpAlphaChannel]="'disabled'" (colorPickerClose)="select($event)">
    </div>
</div>
